<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      readOnly: readOnly$ | async,
      checkValidation: checkValidation$ | async,
    };
    as data
  ) {
    @if (titles) {
      <div
        class="form-group question-container-inner"
        [formGroup]="questionForm"
      >
        <lib-input-container
          [headLine]="
            question.translations?.list['headLine']
              | translate: data.activeLang : question.structure.headLine
          "
          [description]="
            question.translations?.list['description']
              | translate: data.activeLang : question.structure.description
          "
          [labelPrefix]="questionNumber$ | async"
          [label]="
            question.translations?.list['title']
              | translate: data.activeLang : question.title
          "
          [questionMarkText]="
            question.translations?.list['questionMarkText']
              | translate: data.activeLang : question.structure.questionMarkText
          "
          [required]="question.validation.required"
          [for]="labelPrefix + question.id"
          [inputType]="InputType.Amount"
          [helpText]="
            question.translations?.list['helpText']
              | translate: data.activeLang : question.structure.helpText
          "
          [showChangeIndicator]="
            !data.readOnly &&
            showChanges() &&
            previousAnswersService.hasSimpleValueChanged(
              question.id,
              repeaterGroupId,
              value.value
            )
          "
        >
          <lib-interactive-table
            [id]="labelPrefix + question.id"
            [title]="question.title"
            [formControl]="value"
            [rows]="titles.rows"
            [columns]="titles.columns"
            [sumRow]="sumRows"
            [sumCol]="sumColumns"
            [maxColsDesktop]="sumRows ? 6 : 7"
            [maxColsMobile]="sumRows ? 2 : 3"
            [inputType]="inputType"
            [required]="question.validation.required"
            [markAllAsTouched]="markTableAsTouched"
            [suffix]="question.structure.currency"
            [hideExpand]="true"
            [readOnly$]="readOnly$"
            [readonly]="data.readOnly"
            [checkValidation]="data.checkValidation"
            (tableTouched)="onTouched()"
            [hideValidation]="data.readOnly === ReadonlyState.Reader"
            [tableContentToRight]="inputType !== InputType.Text"
          ></lib-interactive-table>
        </lib-input-container>
      </div>
    }
  }
</ng-container>
